'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiCog = function TiCog(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15.6 29.2l0.7 2.5c0.2 0.9 1.1 1.6 2 1.6h1.7c0.9 0 1.8-0.7 2.1-1.6l0.6-2.5c0.2-0.8 1.1-1.4 2-1.1l2.4 0.7c0.9 0.2 2-0.2 2.5-1l0.8-1.4c0.5-0.8 0.3-2-0.4-2.6l-1.8-1.8c-0.6-0.7-0.6-1.7 0-2.3l1.8-1.8c0.7-0.6 0.9-1.8 0.4-2.6l-0.8-1.4c-0.5-0.8-1.6-1.3-2.5-1l-2.4 0.7c-0.9 0.2-1.8-0.3-2-1.2l-0.6-2.5c-0.3-0.8-1.2-1.6-2.1-1.6h-1.7c-0.9 0-1.8 0.8-2 1.6l-0.7 2.5c-0.2 0.9-1.1 1.4-2 1.2l-2.4-0.7c-0.9-0.3-2 0.2-2.4 1l-0.9 1.4c-0.4 0.8-0.3 2 0.4 2.6l1.8 1.8c0.7 0.6 0.7 1.6 0 2.3l-1.8 1.8c-0.7 0.6-0.8 1.8-0.4 2.6l0.9 1.4c0.4 0.8 1.5 1.2 2.4 1l2.4-0.7c0.9-0.3 1.8 0.3 2 1.1z m3.6-11.7c1.8 0 3.3 1.5 3.3 3.3 0 1.9-1.5 3.4-3.3 3.4s-3.4-1.5-3.4-3.4c0-1.8 1.5-3.3 3.4-3.3z' })
        )
    );
};

exports.default = TiCog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/cog.js
// module id = 1852
// module chunks = 0